import React, { Component, Fragment } from 'react';
import withTranslations from '../../../translations/index';
import { Loader } from '../index';
import http from '../../../utils/http';

import AvatarEditor from 'react-avatar-editor';
import RotateRight from '@material-ui/icons/RotateRight';
import Check from '@material-ui/icons/Check';

// Convert a Base64-encoded string to a File object
export const base64StringtoFile = (base64String, filename) => {
  const
    array = base64String.split(','),
    mime = array[0].match(/:(.*?);/)[1],
    bstr = atob(array[1]);

  let
    bstrLength = bstr.length,
    u8arr = new Uint8Array(bstrLength);

  while (bstrLength--) {
    u8arr[bstrLength] = bstr.charCodeAt(bstrLength);
  }

  return new File([u8arr], filename, {type: mime});
};

class ImageManipulation extends Component {
  constructor(props) {
    super();
    this.state = {
      image: props.thumbSrc,
      scale: 1,
      angle: 0,
      position: { x: 0.5, y: 0.5 },
      uploading: false,
      error: undefined
    };
    this.handleRotate = this.handleRotate.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { thumbSrc } = this.props;

    if (prevProps.thumbSrc !== thumbSrc) {
      this.setState({image: thumbSrc, rotate: 0})
    }
  }

  handleRotate = () => {
    this.setState({
      angle: this.state.angle + 90,
    });
  }

  setEditorRef = editor => {
    if (editor) this.editor = editor;
  }

  updateImage = async () => {
    try {
      const {
        fileName: imageFileName,
        rotateImageEndpoint,
        updateFilesAfterUpload
      } = this.props;

      this.setState({ uploading: true });

      const { data: response } = await http.post(rotateImageEndpoint, {
        imageFileName,
        angle: this.state.angle
      });

      updateFilesAfterUpload(response.data);
      this.setState({ uploading: false });
      this.setState({ error: undefined });
      this.setState({ angle: 0 });
    } catch (e) {
      this.setState({ uploading: false });
      this.setState({error: 'Error has occured during rotate picture.'});
    }
  }

  render() {
    const { uploading, error } = this.state;

    if (uploading) {
      return <Loader color='secondary' />;
    } else {
      return (
        <Fragment>
          {error && <div>{error}</div>}
          <AvatarEditor
            ref={this.setEditorRef}
            color={[255, 255, 255]}
            rotate={this.state.angle}
            image={this.state.image}
            crossOrigin="anonymous"
          />
          <div>
            <RotateRight onClick={this.handleRotate} />
            <Check onClick={this.updateImage} />
          </div>
        </Fragment>
      );
    }
  }
}

export default (withTranslations(ImageManipulation, 'ImageManipulation'))



// WEBPACK FOOTER //
// ./src/components/base/ImageManipulation/ImageManipulation.js